import * as serializers from "serializers/legacy/legacy-3mfSerializer";
export { serializers };
export default serializers;
